interface Props {
  checked: boolean;
}

function CheckIcon(props: Props) {
  return (
    <svg
      width={21}
      height={21}
      viewBox="0 0 21 21"
      fill="none"
      style={{marginRight: '6px'}}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 1c5.246 0 9.5 4.254 9.5 9.5S15.746 20 10.5 20 1 15.746 1 10.5 5.254 1 10.5 1z"
        fill="#fff"
        stroke={props.checked ? '#2A2A2A' : '#E8E9E9'}
        strokeWidth={2}
      />
      {props.checked && (
        <path
          d="M9.452 14.365a.459.459 0 01-.65 0l-2.6-2.6a.69.69 0 010-.976l.326-.325a.69.69 0 01.976 0l1.623 1.623 4.384-4.385a.69.69 0 01.976 0l.326.326a.69.69 0 010 .976l-5.361 5.361z"
          fill="#2A2A2A"
        />
      )}
    </svg>
  );
}

export default CheckIcon;
